export const useUserProfileStatus = () => {
  const userStore = useUserStore();
  const { t } = useI18n();

  const licenseFor = (license: string): "pro" | "group" | "basic" => {
    if (["pro", "pro_free"].includes(license)) {
      return "pro";
    }

    if (["group", "group_free"].includes(license)) {
      return "group";
    }

    if (["free", "basic"].includes(license)) {
      return "basic";
    }

    return "basic";
  };

  const profileSubscriptionUrl = "/profile_subscription";
  const companyUrl = "/schule";

  const getCoursesUrl = (license: string) => {
    if (license === "pro") {
      return profileSubscriptionUrl;
    }

    if (license === "group") {
      return companyUrl;
    }

    return "/";
  };

  const getToolsUrl = (license: string) => {
    if (license === "pro") {
      return profileSubscriptionUrl;
    }

    if (license === "group") {
      return companyUrl;
    }

    return "/preistabelle";
  };

  const tools = computed(() => {
    const license = licenseFor(userStore.user?.licenses?.tools || "basic");
    const label = t(`profileStatus.licenses.tools.${license}.label`);
    const tooltip = t(`profileStatus.licenses.tools.${license}.tooltip`);
    return {
      license,
      label,
      url: getToolsUrl(license),
      tooltip,
    };
  });

  const courses = computed(() => {
    const license = licenseFor(userStore.user?.licenses?.courses || "basic");
    const label = t(`profileStatus.licenses.courses.${license}.label`);
    const tooltip = t(`profileStatus.licenses.courses.${license}.tooltip`);
    return {
      license,
      label,
      url: getCoursesUrl(license),
      tooltip,
    };
  });

  return {
    tools,
    courses,
  };
};
